import React, { useMemo } from 'react';
import classNames from 'classnames';
import { Highlight } from 'react-instantsearch';

import { Image } from '@uncinc/uncinc-react-kitchen-sink';

import constructVariableRatiosImageSourcesObject from '../../../../helpers/constructImageSources';
import { taxonomyTagElasticMapper } from '../../../Tags/taxonomyTagMapper';
import Card from '../../../Card';
import type { SearchAllContentVacancyHit as Type } from '../../types';

const SearchAllContentVacancyHit: React.FC<{ hit: Type }> = ({ hit }) => {
  const classes = classNames('SearchAllContentHit', 'SearchAllContentVacancyHit');

  const tags = useMemo(() => (
    taxonomyTagElasticMapper(hit.vacancy_function_name, 'vacancy_function_name')
  ), [hit.vacancy_function_name]);

  return (
    <Card className={classes}>
      <Card.Content>
        <Card.Link href={hit.url[0]}>
          <Card.Title title={<Highlight attribute="page_title" hit={hit} />} />
        </Card.Link>

        <div className="Card__content__metadata">
          <Card.Tags tags={tags} />

          <span className="Card__content__url body--small">
            ...{hit.url[0]}
          </span>
        </div>

        <Card.Subtitle
          subtitle={(
            <p className="u-truncate--3">
              {hit.body_summarized?.[0] ? (
                <Highlight attribute="body_summarized" hit={hit} />
              ) : (
                <Highlight attribute="body" hit={hit} />
              )}
            </p>
          )}
        />
      </Card.Content>

      {/* <Card.Image
        image={(
          <Image
            src={constructVariableRatiosImageSourcesObject(hit, ['4_3', '4_3', '4_3', '4_3', '4_3'])}
            alt={hit.image_alt?.[0]}
            lazyload={false}
          />
        )}
      /> */}
    </Card>
  );
};

export default SearchAllContentVacancyHit;
